import Vue from 'vue'
import sweetAlert from 'sweetalert2'
import { Component } from 'vue-property-decorator'

@Component
export default class SweetAlertService extends Vue {
  protected swalToast (duration: number, ty: string, title: string) {
    sweetAlert({
      toast: true,
      position: 'top',
      showConfirmButton: false,
      timer: duration,
      type: ty,
      title
    } as any)
  }

  protected swalConfirm (title: string) {
    return sweetAlert({
      title,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: this.$t('Yes').toString(),
      cancelButtonText: this.$t('No').toString()
    } as any)
  }

  protected swalAlert (type: string, message: string) {
    sweetAlert({
      html: message,
      type: type,
      showConfirmButton: false
    } as any)
  }

  protected toasterAlert (message: string) {
    this.$notify({
      group: 'alerts',
      type: 'error',
      title: '<b>Alert</b>',
      text: message
    })
  }
}
